import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/nominas/seguro-issste/';

/**
 * GET Configuraciones Seguro ISSSTE
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguracionesSeguroISSSTE = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Configuracion Seguro ISSSTE
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguracionSeguroISSSTE = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configuracion Seguro ISSSTE
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionSeguroISSSTE = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion Seguro ISSSTE
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionSeguroISSSTE = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion Seguro ISSSTE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionSeguroISSSTE = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
